import { render, staticRenderFns } from "./Partie4.vue?vue&type=template&id=1e52a8d8&"
import script from "./Partie4.vue?vue&type=script&lang=js&"
export * from "./Partie4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports